"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgExclamationMarkGold(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("circle", { cx: 12, cy: 12, r: 12, fill: "#FF8A00" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M12 13l.464-6.501a.466.466 0 10-.928 0L12 13z", fill: "#fff" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M12.464 6.499l-.997-.072.997.072zM12 13l-.998.071a1 1 0 001.995 0L12 13zm-.533-6.573l-.465 6.502 1.995.142.465-6.501-1.995-.143zm1.53 6.502l-.464-6.502-1.995.143.464 6.501 1.995-.142zm-.464-6.502A.534.534 0 0112 7V5c-.85 0-1.522.722-1.462 1.57l1.995-.143zm.929.143A1.466 1.466 0 0012 5v2a.534.534 0 01-.533-.573l1.995.143z", fill: "#fff" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M12 17v1", stroke: "#fff", strokeWidth: 2, strokeLinecap: "round" }, void 0)] }), void 0));
}
exports.default = SvgExclamationMarkGold;
//# sourceMappingURL=ExclamationMarkGold.js.map